import { Action } from "redux";
import GeoCalculationItem from "../../dto/GeoCalculationItem";

export const CENTER_MAP_TO_GEOCALCULATION = "CENTER_MAP_TO_GEOCALCULATION";

export interface CenterMapOnGeoCalculationAction extends Action {
    calculationId?: string;
    geoCalculations?: GeoCalculationItem[];
}

export const centerMapOnGeoCalculationAction = (calculationId?: string): CenterMapOnGeoCalculationAction => {
    return {
        type: CENTER_MAP_TO_GEOCALCULATION,
        calculationId: calculationId,
    };
};
